import { PortaledModalFrame } from "src/components/common/PortaledModalFrame";
import {
  orderDrawerPrimaryButtonClass,
  orderDrawerSecondaryButtonClass,
} from "src/constants/orderDrawerButtons";

export interface ConfirmActionModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  loadingLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
}

export function ConfirmActionModal({
  open,
  title,
  message,
  confirmLabel,
  loadingLabel,
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  isLoading = false,
}: ConfirmActionModalProps) {
  if (!open) return null;

  return (
    <PortaledModalFrame
      onClose={isLoading ? () => {} : onCancel}
      panelClassName="max-w-md"
      panelStyle={{ maxWidth: 420 }}
    >
      <div className="px-6 py-5">
        <h2 id="modal-title" className="text-lg font-semibold text-[#111827]">
          {title}
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-[#4B5563]">{message}</p>
        <div className="mt-6 flex flex-wrap justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className={orderDrawerSecondaryButtonClass}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={() => void onConfirm()}
            disabled={isLoading}
            className={orderDrawerPrimaryButtonClass}
          >
            {isLoading ? loadingLabel ?? confirmLabel : confirmLabel}
          </button>
        </div>
      </div>
    </PortaledModalFrame>
  );
}
